export default "__VITE_ASSET__BCM7vC2C__ 96w, __VITE_ASSET__DrMet0uR__ 192w, __VITE_ASSET__BW8D8tgR__ 222w";